const BUSINESS_TYPES = [
  {
    label: "Agricultural Merchant / Farm Store",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Animal Shelter / Charity",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Backgrounder Lot",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Beef Producer",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilers", value: "Broilers", id: "broilers" },
  {
    label: "Buying Group",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Calf Production",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Calf Ranch/Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Cattle Buyer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contract Grower",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperative", value: "Cooperative", id: "cooperative" },
  {
    label: "Afaceretoimisto",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Cow/Calf Operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Dairy Production",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Feed Mill", value: "Feed Mill", id: "feed_mill" },
  { label: "Feedyard", value: "Feedyard", id: "feedyard" },
  {
    label: "Grower/Growyard",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hatchery", value: "Hatchery", id: "hatchery" },
  {
    label: "Heifer Production",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Layer Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Layers", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Milk Cooperative/Buyer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Mixed/Other Producer",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nutrient Supplier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Packer/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Pet Retail Outlet",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacy", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Poultry Breeder",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Poultry Integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Sheep Producer", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Stocker Operation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Stockyard/Salebarn",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Swine Producer", value: "Swine Producer", id: "swine_producer" },
  { label: "Turkeys", value: "Turkeys", id: "turkeys" },
  {
    label: "University / Education",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Veterinarasema",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Wholesaler / Retailer",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wool Buyer", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Obligatoriu",
    },
  },
  salutation: {
    label: "Formula de adresare",
    placeholder: "Selectați formula de adresare",
    errors: {
      required: "Formula de adresare este obligatorie",
      invalid: "Vă rugăm să selectați o formulă de adresare validă",
    },
  },
  firstName: {
    label: "Prenume",
    placeholder: "Ion",
    errors: {
      required: "Prenumele este obligatoriu",
      minLength: "Prenumele trebuie să aibă cel puțin 2 caractere",
      maxLength: "Prenumele poate avea cel mult 50 de caractere",
    },
  },
  lastName: {
    label: "Nume",
    placeholder: "Popescu",
    errors: {
      required: "Numele este obligatoriu",
      minLength: "Numele trebuie să aibă cel puțin 2 caractere",
      maxLength: "Numele poate avea cel mult 50 de caractere",
    },
  },
  email: {
    label: "E-mail",
    placeholder: "ion.popescu@exemplu.ro",
    description:
      "Vă rugăm să introduceți o adresă de e-mail personală, nu o adresă de e-mail partajată.",
    prefixWarningTitle: "Căsuță poștală partajată detectată",
    prefixWarningDescription:
      "Recomandăm utilizarea unei adrese de e-mail personale pentru o experiență mai bună și mai personalizată",
    errors: {
      required: "E-mailul este obligatoriu",
      invalidEmail: "Vă rugăm să introduceți o adresă de e-mail validă",
      emailAssociatedWithYourAccount:
        "Adresa dumneavoastră de e-mail este asociată cu contul dumneavoastră și nu poate fi modificată.",
    },
  },
  confirmEmail: {
    label: "Confirmare e-mail",
    placeholder: "ion.popescu@exemplu.ro",
    errors: {
      required: "Confirmarea e-mailului este obligatorie",
      invalidEmail: "Vă rugăm să introduceți o adresă de e-mail validă",
      emailMatchError: "Adresele de e-mail nu se potrivesc",
    },
  },
  password: {
    label: "Parolă",
    placeholder: "Introduceți parola",
    errors: {
      required: "Parola este obligatorie",
    },
  },
  confirmPassword: {
    label: "Confirmare parolă",
    placeholder: "Confirmați parola",
    errors: {
      required: "Confirmarea parolei este obligatorie",
      passwordMatchError: "Parolele nu se potrivesc",
    },
  },
  addressLine1: {
    label: "Linie adresă 1",
    placeholder: "Strada Victoriei 123",
    errors: {
      required: "Linia de adresă 1 este obligatorie",
      minLength: "Linia de adresă 1 trebuie să aibă cel puțin 5 caractere",
      maxLength: "Linia de adresă 1 poate avea cel mult 100 de caractere",
    },
  },
  addressLine2: {
    label: "Linie adresă 2",
    placeholder: "Apartament 4B",
    errors: {
      required: "Linia de adresă 2 este obligatorie",
      maxLength: "Linia de adresă 2 poate avea cel mult 100 de caractere",
    },
  },
  city: {
    label: "Oraș",
    placeholder: "București",
    errors: {
      required: "Orașul este obligatoriu",
      minLength: "Orașul trebuie să aibă cel puțin 2 caractere",
      maxLength: "Orașul poate avea cel mult 50 de caractere",
    },
  },
  state: {
    label: "Stat",
    placeholder: "Selectați statul",
    errors: {
      required: "Statul este obligatoriu",
      invalid: "Vă rugăm să selectați un stat valid",
    },
  },
  jurisdiction: {
    label: "Jurisdicția licenței",
    placeholder: "Selectați jurisdicția licenței",
    errors: {
      required: "Jurisdicția licenței este obligatorie",
      invalid: "Vă rugăm să selectați o jurisdicție validă",
    },
  },
  zipCode: {
    label: "Cod poștal",
    placeholder: "010101",
    errors: {
      required: "Codul poștal este obligatoriu",
      invalid: "Vă rugăm să introduceți un cod poștal valid",
    },
  },
  role: {
    label: "Rol",
    placeholder: "Selectați rolul dumneavoastră",
    errors: {
      required: "Vă rugăm să selectați rolul dumneavoastră",
      invalid: "Vă rugăm să selectați un rol valid",
    },
  },
  businessType: {
    label: "Tip afacere",
    placeholder: "Selectați tipul de afacere",
    errors: {
      required: "Tipul de afacere este obligatoriu",
      invalid: "Vă rugăm să selectați un tip de afacere valid",
    },
  },
  businessName: {
    label: "Nume afacere",
    placeholder: "Introduceți numele afacerii",
    errors: {
      required: "Numele afacerii este obligatoriu",
      minLength: "Numele afacerii trebuie să aibă cel puțin 2 caractere",
      maxLength: "Numele afacerii poate avea cel mult 100 de caractere",
    },
  },
  businessSearch: {
    label: "Căutare afacere:",
    addNewAccount: "Adăugați un cont de afaceri nou",
    canNotFindBusiness: "Nu găsiți afacerea dumneavoastră?",
    guideline:
      "Vă rugăm să introduceți codul poștal și apoi să selectați din lista de mai jos.",
    guidelineForNameSearch:
      "Vă rugăm să introduceți numele complet al afacerii și apoi să selectați din listă.",
    placeholder: "Unde lucrați?",
    noResults: "Nu au fost găsite rezultate",
    searching: "Se caută...",
    selectedBusinessHeading: "Afacere selectată:",
    selectedBusinessNotCorrect: "Nu este corect?",
    selectedBusinessTryAgain: "Încercați din nou",
    selectedBusinessDismiss: "Respingeți afacerea",
    resultsFound: {
      singular: "1 afacere găsită",
      plural: "Mai multe afaceri găsite",
    },
    errors: {
      network:
        "Întâmpinăm probleme la conectarea la serviciul de căutare a afacerilor. Vă rugăm să încercați din nou mai târziu.",
    },
  },
  explicitConsent: {
    label:
      "Prin bifarea acestei casete accept Termenii de utilizare Elanco și confirm că Elanco va colecta și prelucra datele mele personale în conformitate cu Politica de confidențialitate Elanco",
    errors: {
      required: "Consimțământul prin e-mail este obligatoriu",
    },
  },
  telephone: {
    label: "Telefon personal",
    placeholder: "Introduceți numărul de telefon personal",
    dialCodeLabel: "Cod",
    dialCodePlaceholder: "Căutați țara…",
    errors: {
      invalid: "Vă rugăm să introduceți un număr de telefon valid.",
    },
  },
  businessTelephone: {
    label: "Telefon afacere",
    placeholder: "Introduceți numărul de telefon al afacerii",
    dialCodeLabel: "Cod",
    dialCodePlaceholder: "Căutați țara…",
    errors: {
      invalid: "Vă rugăm să introduceți un număr de telefon valid.",
    },
  },
  professionalNumber: {
    label: "Număr profesional",
    placeholder: "1234567",
    errors: {
      required: "Vă rugăm să introduceți numărul profesional",
      maxLength: "Introducerea depășește limita de caractere",
    },
  },
  addressSearch: {
    errors: {
      required: "Acest câmp este obligatoriu",
    },
  },
  businessSearchField: {
    errors: {
      required: "Acest câmp este obligatoriu",
    },
  },
  checkbox: {
    errors: {
      required: "Acest câmp este obligatoriu",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Acest câmp este obligatoriu",
    },
  },
  combobox: {
    errors: {
      required: "Acest câmp este obligatoriu",
    },
  },
  datePicker: {
    errors: {
      required: "Acest câmp este obligatoriu",
    },
  },
  dateRange: {
    errors: {
      required: "Acest câmp este obligatoriu",
    },
  },
  dateTime: {
    errors: {
      required: "Acest câmp este obligatoriu",
    },
  },
  emailField: {
    errors: {
      required: "Acest câmp este obligatoriu",
    },
  },
  fileInput: {
    errors: {
      required: "Vă rugăm să selectați un fișier",
    },
  },
  number: {
    errors: {
      required: "Vă rugăm să introduceți un număr",
      minValue: "Vă rugăm să introduceți o valoare mai mare decât minimul",
      maxValue: "Vă rugăm să introduceți o valoare mai mică decât maximul",
    },
  },
  passwordField: {
    errors: {
      required: "Acest câmp este obligatoriu",
    },
  },
  rangeSlider: {
    errors: {
      required: "Acest câmp este obligatoriu",
    },
  },
  select: {
    errors: {
      required: "Acest câmp este obligatoriu",
    },
  },
  telephoneField: {
    errors: {
      required: "Vă rugăm să introduceți doar cifre",
      invalidTelephone: "Vă rugăm să introduceți un număr de telefon valid",
      invalidFormat: "Format de număr invalid",
    },
  },
  text: {
    errors: {
      required:
        "Vă rugăm să utilizați doar litere (A-Z), cifre (0-9) și fără simboluri",
      maxLength: "Introducerea depășește limita de caractere",
      minLength: "Introducerea trebuie să aibă cel puțin 2 caractere",
    },
  },
  textarea: {
    characters: "merkkiä",
  },
  time: {
    errors: {
      required: "Acest câmp este obligatoriu",
    },
  },
  form: {
    errors: {
      generic:
        "A apărut o eroare la trimiterea formularului. Vă rugăm să încercați din nou.",
      reportAnIssue: "Vă rugăm să raportați o problemă.",
      configuration: "Eroare de configurare",
      noFormQuestionsAvailable: "Nu sunt disponibile întrebări de formular.",
      formComponentLoad:
        "Componenta de formular nu a putut fi încărcată din cauza unui câmp neacceptat.",
      code: "Cod",
      type: "Tip",
      missingRequiredFields:
        "Acestui formular îi lipsesc câmpurile obligatorii (E-mail și/sau Consimțământ). Vă rugăm să contactați un administrator pentru a corecta configurația formularului.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Eläintensuojelu - Veterinar",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Animal Welfare - Vet Nurse",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Animal Welfare - Volunteer",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Beef Producer",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Business Owner / Partner",
    id: "business_owner_partner",
  },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Corporate Veterinary Employee (non-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Office/Practice Manager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Pharmacist", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacy - Staff",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Practice Owner, Non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Client Service",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Veterinar",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Veterinar", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Veterinar, Vastanoton omistaja",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Veterinaravustaja",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinary Nurse",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Veterinarasema - Muu",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Veterinarasema - Veterinar",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Veterinarasema - Eläinhoitaja",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Veterinarasiantuntija",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinary Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Veterinar",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Wholesaler", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Domnul",
    value: "M.",
    id: "m",
  },
  {
    label: "Miss",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Domnul",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Doamna",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Doamna/Neiti",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Profesor",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
